<template>
    <span class="badge text-white" v-bind:style="{ background: activeColor}">{{item_type.name}}</span>
</template>

<script>
    export default {
        props: ['item_type'],
        data(){
            return {
                activeColor: '#fff'
            }
        },
        created: function () {
            this.updateColor();
        },
        methods: {
            updateColor: function(){
                this.activeColor = this.item_type.color;
            },
            renderColor: function(){
                return this.item_type.color;
            },
            renderName: function(){
                return this.item_type.name;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/projects/ProjectTypeLabel.vue